// extracted by mini-css-extract-plugin
export default {"termsSection":"Terms_termsSection__jG5Iw"};